export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Contact Us',
      description: 'Call (915) 206-5814 or fill out our form. Tell us about your property and the title issues you\'re facing. We\'ve heard it all - liens, probate, boundary disputes, missing heirs - nothing scares us away.',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: 'Free Title Consultation',
      description: 'We\'ll review your situation and explain your options. We can often identify solutions you didn\'t know existed. This consultation is completely free with no obligation.',
      icon: 'ri-discuss-line'
    },
    {
      number: '03',
      title: 'Property Evaluation',
      description: 'We\'ll visit the property and assess its condition. Unlike traditional buyers, we buy houses as-is, so don\'t worry about repairs or cleaning. We just need to see the property.',
      icon: 'ri-home-smile-line'
    },
    {
      number: '04',
      title: 'Cash Offer',
      description: 'Within 24-48 hours, we\'ll present a fair cash offer. Our offer accounts for the title issues and the work we\'ll need to do to resolve them. No hidden fees, no commissions, no surprises.',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      number: '05',
      title: 'Title Work',
      description: 'We work with our title company to identify all liens, clouds, and defects. We handle negotiations with lien holders, heir searches, probate coordination - all the complicated stuff.',
      icon: 'ri-file-search-line'
    },
    {
      number: '06',
      title: 'Close & Get Paid',
      description: 'Close at a reputable title company in 7-14 days (or longer if probate is pending). We pay off all liens at closing. You walk away with cash in hand and all problems solved.',
      icon: 'ri-check-double-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Simple <strong>6-Step Process</strong>
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            We've streamlined the process of <strong>selling a house with title issues</strong> to make it as easy as possible for you. No stress, no complications, no surprises.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow relative">
              <div className="absolute top-6 right-6 text-6xl font-bold text-emerald-50">
                {step.number}
              </div>
              <div className="relative z-10">
                <div className="w-16 h-16 bg-emerald-500 rounded-full flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-700 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-lg shadow-xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/91831ca270179dc46214a317b670d922.jpg"
                alt="Successful closing with title company"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Why Our Process Works</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-emerald-600 flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-gray-900">We're Experienced</p>
                    <p className="text-gray-700">We've closed 200+ deals with title issues. We know what works and what doesn't.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-emerald-600 flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-gray-900">We're Connected</p>
                    <p className="text-gray-700">We have relationships with title companies, attorneys, and lien holders that help us resolve issues faster.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-emerald-600 flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-gray-900">We're Committed</p>
                    <p className="text-gray-700">We don't walk away when problems surface. We work through them until closing.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-emerald-600 flex-shrink-0"></i>
                  <div>
                    <p className="font-semibold text-gray-900">We're Fair</p>
                    <p className="text-gray-700">Our offers account for title issues but are still competitive. We want win-win deals.</p>
                  </div>
                </li>
              </ul>
              <div className="mt-8">
                <a 
                  href="tel:9152065814"
                  className="inline-block bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                >
                  Start Your Sale Today
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}